var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserpic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.36 14.2299C12.9826 15.3404 11.0174 15.3404 9.64 14.2299C9.21474 13.8765 8.58346 13.9347 8.23 14.3599C7.87654 14.7852 7.93474 15.4165 8.36 15.7699C10.4677 17.5294 13.5323 17.5294 15.64 15.7699C15.9151 15.5413 16.0473 15.1832 15.9868 14.8307C15.9264 14.4781 15.6824 14.1846 15.3468 14.0607C15.0113 13.9367 14.6351 14.0013 14.36 14.2299ZM9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44771 9 8 9.44772 8 10C8 10.5523 8.44771 11 9 11ZM15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9ZM12 1.99988C6.47715 1.99988 2 6.47703 2 11.9999C2 17.5227 6.47715 21.9999 12 21.9999C17.5228 21.9999 22 17.5227 22 11.9999C22 9.34771 20.9464 6.80417 19.0711 4.92881C17.1957 3.05345 14.6522 1.99988 12 1.99988ZM12 19.9998C7.58172 19.9998 4 16.418 4 11.9998C4 7.58148 7.58172 3.99975 12 3.99975C16.4183 3.99975 20 7.58148 20 11.9998C20 14.1215 19.1571 16.1563 17.6569 17.6566C16.1566 19.1569 14.1217 19.9998 12 19.9998Z",
    fill: "#9F248F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserpic);
export default __webpack_public_path__ + "static/media/userpic.d83bcbde.svg";
export { ForwardRef as ReactComponent };